import { render, staticRenderFns } from "./CampaignsIndex.vue?vue&type=template&id=53982e02"
import script from "./CampaignsIndex.vue?vue&type=script&lang=js"
export * from "./CampaignsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports